import React from "react";
import { Text, Box, Icon } from "@showitinc/showit-wc";
import { toPrettyDate } from "../../utils/DateUtils";
import styles from "./RecordsTable.module.css";
import { copyToClipboard } from "../../utils/AppUtils";

const RecordsTable = ({ records }) => {
  const _copyExportKey = async (key) => {
    await copyToClipboard({
      val: key,
      showToast: true,
    });
  };

  const recordList = records.map((record) => (
    <tr key={`record ${record.export_id}`}>
      <td>
        <Text>{record.name}</Text>
      </td>
      <td className={styles.key} onClick={() => _copyExportKey(record.key)}>
        <Box d="flex" justify="between">
          <Text>{record.key}</Text>
          <Icon type="copy16" size="16" />
        </Box>
      </td>
      <td>
        <Text>{toPrettyDate(record.last_updated)}</Text>
      </td>
    </tr>
  ));

  return (
    <table className={styles.table}>
      <tbody>
        <tr>
          <th>
            <Text variantStyle="bold">Name</Text>
          </th>
          <th>
            <Text variantStyle="bold">Share Key</Text>
          </th>
          <th>
            <Text variantStyle="bold">Last Modified</Text>
          </th>
        </tr>
        {recordList}
      </tbody>
    </table>
  );
};
export default RecordsTable;
